<div class="flex h-full flex-col">
  <mat-sidenav-container class="shell-container h-full">
    <mat-sidenav [disableClose]="true" mode="side" [opened]="true" class="border-r border-neutral-200">
      <div class="flex h-full flex-col">
        <!-- Overview Back Button -->
        <div class="h-[41px] w-full">
          <a
            [routerLink]="['/', CmsUrlParts.Overview]"
            class="flex h-full w-full items-center border-b px-4 py-3 text-xs font-medium text-gray-500 hover:bg-gray-50"
          >
            <dojo-icon [icon]="'arrow-left'" [size]="14" class="mr-2" />
            <span>Return to Overview</span>
          </a>
        </div>

        <div class="px-4 pt-3">
          <exam-syllabus-select />
        </div>

        <div class="flex grow flex-col items-start gap-4">
          <div class="flex w-full flex-col items-start gap-2 p-4">
            <div class="flex w-full flex-col gap-0.5">
              <ng-container
                *ngTemplateOutlet="
                  link;
                  context: {
                    icon: 'book',
                    label: 'Sources',
                    route: ['/', CmsUrlParts.Syllabus, state.syllabusSlug, CmsUrlParts.Sources]
                  }
                "
              />
              <ng-container
                *ngTemplateOutlet="
                  link;
                  context: {
                    icon: 'seedling',
                    label: 'Reference',
                    route: ['/', CmsUrlParts.Syllabus, state.syllabusSlug, CmsUrlParts.ReferenceQuestions]
                  }
                "
              />
              <ng-container *dojoIfUserHasRole="'ADMIN'">
                <ng-container
                  *ngTemplateOutlet="
                    link;
                    context: {
                      icon: 'square-question',
                      label: 'Questions',
                      route: ['/', CmsUrlParts.Syllabus, state.syllabusSlug, CmsUrlParts.Questions]
                    }
                  "
                />

                <ng-container
                  *ngTemplateOutlet="
                    link;
                    context: {
                      icon: 'list',
                      label: 'Syllabus',
                      route: ['/', CmsUrlParts.Syllabus, state.syllabusSlug, CmsUrlParts.Syllabus]
                    }
                  "
                />
              </ng-container>
            </div>
          </div>

          <div class="mt-auto flex w-full flex-col gap-1 p-4">
            @if (state.user) {
              <a
                [matMenuTriggerFor]="userMenu"
                class="text-secondary flex w-full max-w-full items-center gap-2 rounded-[0.75rem] px-2 py-1.5 font-semibold transition-colors hover:bg-neutral-50 group-[.is-compact]:px-2"
              >
                <dojo-profile-avatar [size]="20" class="shrink-0" />
                <span class="truncate text-sm" [matTooltip]="state.user.fullName">{{ state.user.fullName }}</span>
              </a>
            }
          </div>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="!overflow-hidden bg-white">
      <div class="h-full overflow-y-auto">
        <router-outlet />
        <ng-content />
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<mat-menu #userMenu="matMenu" class="custom-mat-menu">
  <button
    mat-menu-item
    (click)="openLanguageDialog()"
    data-test="user-top-nav-menu-button-user-settings"
    *ngIfFeatureFlag="ExamDojoFeatureFlag.Testing"
  >
    <dojo-icon class="menu-icon" icon="language" />
    <span class="menu-item-label">Language</span>
  </button>

  <button mat-menu-item (click)="logout()">
    <dojo-icon class="menu-icon" [icon]="'arrow-right-from-bracket'" />
    <span class="menu-item-label">{{ 'examdojo.registration.sign_out' | transloco }}</span>
  </button>
</mat-menu>

<ng-template #link let-label="label" let-route="route" let-icon="icon">
  <a
    class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
    [routerLink]="route"
    routerLinkActive="active"
    #rla="routerLinkActive"
  >
    <dojo-icon
      [icon]="icon"
      [iconClass]="rla.isActive ? 'text-sky-500' : 'text-secondary'"
      [size]="12"
      class="mr-1.5"
    ></dojo-icon>
    <span class="truncate" [matTooltip]="label">{{ label }}</span>
  </a>
</ng-template>
